// extracted by mini-css-extract-plugin
export default {"button":"button_button__0On-O","spinner":"button_spinner__hwxXE","rotate":"button_rotate__S7-Fe"};